// extracted by mini-css-extract-plugin
module.exports = {"loadingContainer":"ShortCoursesCheckoutPage_loadingContainer_2z6UC"};